export const exportPlayerProfileAnthroDetails = (
  anthrosSummaryData,
  getLengthUnitLabelType,
  getLengthUnitValue,
  getWeightUnitLabelType,
  getWeightUnitValue,
  lengthUnits,
  weightUnits,
  getHandDimensionsUnitValue,
  getHandDimensionsUnitLabelType,
  selectedEvent
) => {
  const styleHeaderCss = {
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "e6eefb" },
    },
    font: { sz: "11", bold: true, color: { argb: "1d428a" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    alignment: {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    },
  };

  const anthrosSummary = {
    title: "Anthropometry Summary",
    headerNames: [
      {
        title: `Standing Reach ${getLengthUnitLabelType(lengthUnits)}`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Wingspan ${getLengthUnitLabelType(lengthUnits)}`,
        width: 30,
        style: styleHeaderCss,
      },
      // {
      //   title: `Height (w/ shoes) ${getLengthUnitLabelType(lengthUnits)}`,
      //   width: 30,
      //   style: styleHeaderCss,
      // },
      {
        title: `Height (w/o shoes) ${getLengthUnitLabelType(lengthUnits)}`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Body Weight ${getWeightUnitLabelType(weightUnits)}`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Hand Width Inches",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Hand Length Inches",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Body Fat Percentage",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "DEXA Body Fat Percentage",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Abduction Peak Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Abduction Relative Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Abduction Peak Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Abduction Relative Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Abduction Percentage Diff.`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Adduction Peak Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Adduction Relative Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Adduction Peak Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Adduction Relative Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Hip Adduction Percentage Diff.`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Extension Peak Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Extension Relative Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Extension Peak Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Extension Relative Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Extension Percentage Diff.`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Flexion Peak Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Flexion Relative Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Flexion Peak Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Flexion Relative Force (R)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Knee Flexion Percentage Diff.`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Ankle Plantar Flexion Peak Force (L)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Ankle Plantar Flexion Relative Force (L)`,
        width: 40,
        style: styleHeaderCss,
      },
      {
        title: `Ankle Plantar Flexion Peak Force (R)`,
        width: 40,
        style: styleHeaderCss,
      },
      {
        title: `Ankle Plantar Flexion Relative Force (R)`,
        width: 40,
        style: styleHeaderCss,
      },
      {
        title: `Ankle Plantar Flexion Percentage Diff.`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Femur L Length (cm)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Femur R Length (cm)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Fibula L Length (cm)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Fibula R Length (cm)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Short Foot L Length (cm)`,
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Short Foot R Length (cm)`,
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      Object.keys(anthrosSummaryData).length === 0
        ? []
        : [
            {
              standingReachFeet:
                anthrosSummaryData?.standingReachFeet !== null &&
                anthrosSummaryData?.standingReachFeet !== ""
                  ? getLengthUnitValue(
                      anthrosSummaryData.standingReachFeet,
                      anthrosSummaryData.standingReachInches
                    )
                  : "--",
              wingSpanFeet:
                anthrosSummaryData?.wingSpanFeet !== null &&
                anthrosSummaryData?.wingSpanFeet !== ""
                  ? getLengthUnitValue(
                      anthrosSummaryData.wingSpanFeet,
                      anthrosSummaryData.wingSpanInches
                    )
                  : "--",
              // heightWithShoesFeet:
              //   anthrosSummaryData?.heightWithShoesFeet !== null &&
              //   anthrosSummaryData?.heightWithShoesFeet !== ""
              //     ? getLengthUnitValue(
              //         anthrosSummaryData.heightWithShoesFeet,
              //         anthrosSummaryData.heightWithShoesInches
              //       )
              //     : "--",
              heightWithOutShoesFeet:
                anthrosSummaryData?.heightWithOutShoesFeet !== null &&
                anthrosSummaryData?.heightWithOutShoesFeet !== ""
                  ? getLengthUnitValue(
                      anthrosSummaryData.heightWithOutShoesFeet,
                      anthrosSummaryData.heightWithOutShoesInches
                    )
                  : "--",
              bodyWeight: anthrosSummaryData?.bodyWeight
                ? getWeightUnitValue(anthrosSummaryData.bodyWeight)
                : "--",
              handWidth: anthrosSummaryData?.handWidth
                ? getHandDimensionsUnitValue(anthrosSummaryData.handWidth)
                : "--",
              handLength: anthrosSummaryData?.handLength
                ? getHandDimensionsUnitValue(anthrosSummaryData.handLength)
                : "--",
              bodyFat:
                anthrosSummaryData?.bodyFat &&
                !anthrosSummaryData?.isTeamUserDataRestrict
                  ? anthrosSummaryData.bodyFat
                  : "--",
              bodyFatDXA:
                anthrosSummaryData.bodyFatDXA &&
                !anthrosSummaryData?.isTeamUserDataRestrict
                  ? anthrosSummaryData.bodyFatDXA
                  : "--",
              hipAbductionPeakForceL:
                anthrosSummaryData?.hipAbductionPeakForceL || 0,
              hipAbductionRelativeForceL:
                anthrosSummaryData?.hipAbductionRelativeForceL || 0,
              hipAbductionPeakForceR:
                anthrosSummaryData?.hipAbductionPeakForceR || 0,
              hipAbductionRelativeForceR:
                anthrosSummaryData?.hipAbductionRelativeForceR || 0,
              hipAbductionRelativeForcePercentageDiff:
                anthrosSummaryData?.hipAbductionRelativeForcePercentageDiff ||
                0,
              hipAdductionPeakForceL:
                anthrosSummaryData?.hipAdductionPeakForceL || 0,
              hipAdductionRelativeForceL:
                anthrosSummaryData?.hipAdductionRelativeForceL || 0,
              hipAdductionPeakForceR:
                anthrosSummaryData?.hipAdductionPeakForceR || 0,
              hipAdductionRelativeForceR:
                anthrosSummaryData?.hipAdductionRelativeForceR || 0,
              hipAdductionRelativeForcePercentageDiff:
                anthrosSummaryData?.hipAdductionRelativeForcePercentageDiff ||
                0,
              kneeExtensionPeakForceL:
                anthrosSummaryData?.kneeExtensionPeakForceL || 0,
              kneeExtensionRelativeForceL:
                anthrosSummaryData?.kneeExtensionRelativeForceL || 0,
              kneeExtensionPeakForceR:
                anthrosSummaryData?.kneeExtensionPeakForceR || 0,
              kneeExtensionRelativeForceR:
                anthrosSummaryData?.kneeExtensionRelativeForceR || 0,
              kneeExtensionRelativeForcePercentageDiff:
                anthrosSummaryData?.kneeExtensionRelativeForcePercentageDiff ||
                0,
              kneeFlexionPeakForceL:
                anthrosSummaryData?.kneeFlexionPeakForceL || 0,
              kneeFlexionRelativeForceL:
                anthrosSummaryData?.kneeFlexionRelativeForceL || 0,
              kneeFlexionPeakForceR:
                anthrosSummaryData?.kneeFlexionPeakForceR || 0,
              kneeFlexionRelativeForceR:
                anthrosSummaryData?.kneeFlexionRelativeForceR || 0,
              kneeFlexionRelativeForcePercentageDiff:
                anthrosSummaryData?.kneeFlexionRelativeForcePercentageDiff || 0,
              AnklePlantarFlexionPeakForceL:
                anthrosSummaryData?.anklePlantarFlexionPeakForceL || 0,
              anklePlantarFlexionRelativeForceL:
                anthrosSummaryData?.anklePlantarFlexionRelativeForceL || 0,
              AnklePlantarFlexionPeakForceR:
                anthrosSummaryData?.anklePlantarFlexionPeakForceR || 0,
              anklePlantarFlexionRelativeForceR:
                anthrosSummaryData?.anklePlantarFlexionRelativeForceR || 0,
              anklePlantarFlexionRelativeForcePercentageDiff:
                anthrosSummaryData?.anklePlantarFlexionRelativeForcePercentageDiff ||
                0,
              femurLLength: anthrosSummaryData?.femurLLength || 0,
              femurRLength: anthrosSummaryData?.femurRLength || 0,
              fibulaLLength: anthrosSummaryData?.fibulaLLength || 0,
              fibulaRLength: anthrosSummaryData?.fibulaRLength || 0,
              shortFootLLength: anthrosSummaryData?.shortFootLLength || 0,
              shortFootRLength: anthrosSummaryData?.shortFootRLength || 0,
            },
          ],
    columnStyles: Array(40).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  return [anthrosSummary];
};
